import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'findRevendeur'
})
export class FindRevendeurPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if(!value) return null;
    if(!args) return value;

    args = args.toLowerCase();

    return value.filter((item: any) => {

      return JSON.stringify(item.Adresse).toLowerCase().includes(args) || JSON.stringify(item.Phone).toLowerCase().includes(args)|| JSON.stringify(item.Ville).toLowerCase().includes(args)|| JSON.stringify(item.boutique).toLowerCase().includes(args);
    })
  }

}
